module.exports = __webpack_public_path__ + "videos/optimised/06685913b966eb59f9dff2551040e1b5.mp4";